import {
  PATH_ROOT,
  PATH_TIMESHEET_ENTRIES,
  PATH_TIMESHEET_ENTRIES_SHIFT_REPORTS,
} from "@/constants";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { ReadTimesheetEntryContractorVisit } from "@/types/timesheetEntryContractorVisit";
import { ReadShiftReport } from "@/types/shiftReport";
import { UseQueryResult } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { SuccessFetchListResponse } from "@/services/api";
import { generatePath } from "react-router-dom";

interface UseTimesheetEntriesBreadcrumbProps {
  shiftReportQuery?: UseQueryResult<ReadShiftReport>;
  visitsListQuery?: UseQueryResult<
    SuccessFetchListResponse<ReadTimesheetEntryContractorVisit>
  >;
  appendLabel?: string;
}

export const useTimesheetEntriesBreadcrumb = (
  props?: UseTimesheetEntriesBreadcrumbProps,
) => {
  const { t } = useTranslation();

  const breadcrumbItems: BreadcrumbItem[] = [
    { label: t("breadcrumb.home"), href: PATH_ROOT },
    {
      label: t("timesheetEntries.title.multiple"),
      href: PATH_TIMESHEET_ENTRIES,
    },
  ];

  if (props && props.shiftReportQuery && props.shiftReportQuery.data) {
    breadcrumbItems.push({
      label: t("timesheetEntries.shiftReports.breadcrumb", {
        name: props.shiftReportQuery.data.shift_name,
      }),
      href: generatePath(PATH_TIMESHEET_ENTRIES_SHIFT_REPORTS, {
        shiftReportId: props.shiftReportQuery.data.id,
      }),
    });
  }

  if (props && props.visitsListQuery && props.visitsListQuery.data) {
    const firstVisit = props.visitsListQuery.data.items[0];
    breadcrumbItems.push({
      label: t("timesheetEntries.visits.breadcrumb", {
        name: firstVisit?.contractor_name,
      }),
    });
  }

  if (props && props.appendLabel) {
    breadcrumbItems.push({
      label: props.appendLabel,
    });
  }

  return breadcrumbItems;
};
